// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Боковая навигация + узкая верхняя полоса.
   Ширина сайдбара — переменная, от неё же считается отступ
   контента, чтобы страницы не пересчитывали её вручную.
   ============================================================ */

:root {
  --sb-width: 248px;
  --sb-width-collapsed: 72px;
  --tb-height: 56px;
  /* Сколько по высоте занимают шапка и отступы контента —
     используется страницами, которые тянутся на весь экран. */
  --app-content-offset: 150px;
}

.app-layout {
  min-height: 100vh;
}

/* ── Сайдбар ── */
.sb {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1100;
  width: var(--sb-width);
  display: flex;
  flex-direction: column;
  background: var(--bg-glass-heavy, #fff);
  border-right: 1px solid var(--border-color, rgba(148, 163, 184, 0.2));
  backdrop-filter: blur(12px);
  transition: width 0.2s ease, transform 0.2s ease;
}

/* Свёрнутый сайдбар прячется полностью — навигация остаётся в поиске (Ctrl+K) */
.sb--collapsed {
  transform: translateX(-100%);
}

.sb-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 12px;
  min-height: var(--tb-height);
  border-bottom: 1px solid var(--border-color, rgba(148, 163, 184, 0.16));
}

.sb-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.sb-logo {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
}

.sb-brand-texts {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.sb-brand-name {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--text-primary);
  line-height: 1.1;
}

.sb-brand-sub {
  color: var(--text-secondary);
  font-size: 0.72rem;
}

.sb-collapse-btn,
.tb-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
}

.sb-collapse-btn:hover,
.tb-btn:hover {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));
  color: var(--text-primary);
}

/* Глобальное легаси-правило делает любой <nav> фиксированным — перебиваем */
.sb .sb-nav {
  position: static;
  inset: auto;
  background: transparent;
  box-shadow: none;
  z-index: auto;
}

.sb-nav {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.sb-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sb-section-label {
  padding: 4px 10px 6px;
  color: var(--text-secondary);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.sb-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease;
}

.sb-item:hover {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));
}

.sb-item.active {
  background: var(--nav-active-bg, rgba(37, 99, 235, 0.1));
  color: var(--accent-primary, #2563eb);
  font-weight: 600;
}

.sb-item-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 22px;
}

.sb-item-label {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sb--collapsed .sb-item {
  justify-content: center;
  padding: 10px 0;
}

.sb-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--accent-error, #dc2626);
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
}

.sb-badge--dot {
  position: absolute;
  transform: translate(12px, -10px);
  min-width: 8px;
  width: 8px;
  height: 8px;
  padding: 0;
}

.sb--collapsed .sb-item {
  position: relative;
}

/* ── Подвал сайдбара: профиль, язык, выход ── */
.sb-foot {
  position: relative;
  padding: 10px;
  border-top: 1px solid var(--border-color, rgba(148, 163, 184, 0.16));
}

.sb-user {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.18));
  border-radius: 12px;
  background: transparent;
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
}

.sb-user:hover {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.12));
}

.sb-user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 50%;
  background: var(--accent-primary, #2563eb);
  color: #fff;
  font-weight: 700;
  font-size: 0.85rem;
}

.sb-user-texts {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}

.sb-user-name {
  font-size: 0.85rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sb-user-role {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
}

.sb-user-role.dev { color: #a855f7; }
.sb-user-role.admin { color: #dc2626; }
.sb-user-role.moderator { color: #d97706; }
.sb-user-role.support { color: #059669; }

.sb-user-menu {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: calc(100% - 4px);
  z-index: 20;
  padding: 8px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));
  border-radius: 12px;
  background: var(--bg-glass-heavy, #fff);
  box-shadow: 0 18px 40px -18px rgba(15, 23, 42, 0.45);
}

.sb-user-menu-label {
  display: block;
  padding: 4px 6px;
  color: var(--text-secondary);
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.sb-langs {
  display: flex;
  gap: 6px;
  padding: 4px 4px 8px;
}

.sb-lang {
  flex: 1 1;
  padding: 6px 4px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.25));
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
}

.sb-lang.active {
  background: var(--accent-primary, #2563eb);
  border-color: var(--accent-primary, #2563eb);
  color: #fff;
}

.sb-user-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

.sb-user-menu-item:hover {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));
}

.sb-user-menu-item.logout {
  color: var(--accent-error, #dc2626);
}

/* ── Верхняя полоса ── */
.tb {
  position: sticky;
  top: 0;
  z-index: 900;
  display: flex;
  align-items: center;
  gap: 6px;
  height: var(--tb-height);
  padding: 0 16px;
  background: var(--bg-glass, rgba(255, 255, 255, 0.75));
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border-color, rgba(148, 163, 184, 0.16));
}

.tb-spacer {
  flex: 1 1;
}

.tb-burger {
  display: none;
}

/* ── Контент рядом с сайдбаром ── */
.app-body {
  margin-left: var(--sb-width);
  min-height: 100vh;
  transition: margin-left 0.2s ease;
}

.app-body--collapsed {
  margin-left: 0;
}

/* Прежняя разметка рассчитывала на фиксированный навбар сверху */
.app-layout .main-content {
  margin-top: 0;
  padding: 20px 24px;
  min-height: calc(100vh - var(--tb-height));
}

.sb-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
}

/* ── Мобильные: сайдбар выезжает поверх контента ── */
@media (max-width: 1024px) {
  .sb {
    transform: translateX(-100%);
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.25);
    width: var(--sb-width);
  }

  .sb--open {
    transform: translateX(0);
  }

  /* В выдвижной панели свёрнутый режим не имеет смысла */
  .sb--collapsed {
    width: var(--sb-width);
  }

  .sb--collapsed .sb-item {
    justify-content: flex-start;
    padding: 9px 10px;
  }

  .sb-collapse-btn {
    display: none;
  }

  .app-body,
  .app-body--collapsed {
    margin-left: 0;
  }

  .tb-burger {
    display: inline-flex;
  }

  .app-layout .main-content {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  :root {
    --sb-width: 82vw;
    --app-content-offset: 130px;
  }

  .app-layout .main-content {
    padding: 12px;
  }
}

/* Логотип: светлый и тёмный варианты знака */
.brand-logo {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
}

.brand-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 22%;
}

.brand-logo-img--dark {
  display: none;
}

:root[data-theme='dark'] .brand-logo-img--light {
  display: none;
}

:root[data-theme='dark'] .brand-logo-img--dark {
  display: block;
}

/* ── Поиск и быстрые ссылки в верхней полосе ── */
.tb-collapse {
  display: inline-flex;
}

.tb-search {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(340px, 40vw);
  padding: 7px 10px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));
  border-radius: 10px;
  background: var(--bg-secondary, rgba(148, 163, 184, 0.08));
  color: var(--text-secondary);
}

.tb-search input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.86rem;
}

.tb-kbd {
  padding: 2px 6px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));
  border-radius: 6px;
  color: var(--text-secondary);
  font-size: 0.68rem;
  font-family: var(--font-data, monospace);
  white-space: nowrap;
}

.tb-search-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  z-index: 1000;
  max-height: 320px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));
  border-radius: 12px;
  background: var(--bg-glass-heavy, #fff);
  backdrop-filter: blur(12px);
  box-shadow: 0 18px 44px -18px rgba(15, 23, 42, 0.5);
}

.tb-search-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.88rem;
  text-align: left;
  cursor: pointer;
}

.tb-search-item.active {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.16));
}

.tb-search-label {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tb-search-group {
  color: var(--text-secondary);
  font-size: 0.72rem;
  white-space: nowrap;
}

.tb-search-empty {
  padding: 12px;
  color: var(--text-secondary);
  font-size: 0.85rem;
  text-align: center;
}

.tb-quick {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tb-quick-link {
  display: inline-flex;
  align-items: center;
  height: 34px;
  padding: 0 12px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.86rem;
  font-weight: 500;
  cursor: pointer;
}

.tb-quick-link:hover {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));
  color: var(--text-primary);
}

.tb-quick-link.active {
  color: var(--text-primary);
  font-weight: 600;
}

@media (max-width: 1024px) {
  .tb-collapse {
    display: none;
  }

  .tb-quick,
  .tb-divider {
    display: none;
  }

  .tb-kbd {
    display: none;
  }

  .tb-search {
    width: auto;
    flex: 1 1;
  }
}

/* ── Палитра переходов (поиск в верхней полосе) ── */
.tb-search {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(340px, 40vw);
  padding: 8px 12px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));
  border-radius: 10px;
  background: var(--bg-secondary, rgba(148, 163, 184, 0.08));
  color: var(--text-secondary);
  cursor: pointer;
}

.tb-search:hover {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.16));
}

.tb-search-text {
  flex: 1 1;
  text-align: left;
  font-size: 0.86rem;
}

.tb-palette-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1500;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12vh 24px 24px;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(3px);
}

.tb-palette {
  width: min(520px, 100%);
  max-height: 62vh;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));
  border-radius: 16px;
  background: var(--bg-primary, #fff);
  color: var(--text-primary);
  box-shadow: 0 28px 70px -24px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.tb-palette-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 8px;
}

.tb-palette-head h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.tb-palette-input {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 16px 10px;
  padding: 9px 12px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.25));
  border-radius: 10px;
  color: var(--text-secondary);
}

.tb-palette-input input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.9rem;
}

.tb-palette-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0 8px 12px;
}

.tb-palette-group-label {
  display: block;
  padding: 10px 10px 6px;
  color: var(--text-secondary);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.tb-palette-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.92rem;
  text-align: left;
  cursor: pointer;
}

.tb-palette-item.active,
.tb-palette-item:hover {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.16));
}

/* ── Список событий календаря ── */

/* ── Переключатель языка в верхней полосе ── */
.lang-menu {
  position: relative;
}

.lang-menu-trigger {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  height: 34px;
  padding: 0 9px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
}

.lang-menu-trigger:hover,
.lang-menu-trigger.open {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));
  color: var(--text-primary);
}

.lang-menu-list {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1200;
  min-width: 180px;
  padding: 6px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));
  border-radius: 12px;
  background: var(--bg-glass-heavy, #fff);
  backdrop-filter: blur(12px);
  box-shadow: 0 18px 44px -18px rgba(15, 23, 42, 0.45);
}

.lang-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 9px 12px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.9rem;
  text-align: left;
  cursor: pointer;
}

.lang-menu-item:hover {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));
}

.lang-menu-item.active {
  font-weight: 600;
  color: var(--accent-primary, #2563eb);
}

.lang-menu-list {
  animation: lang-menu-in 0.15s ease-out;
}

@keyframes lang-menu-in {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Общий тултип: тёмная плашка под кнопкой (язык, тема) */
.ui-tip-wrap {
  position: relative;
  display: inline-flex;
}

.ui-tip {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%) translateY(-4px);
  z-index: 1250;
  padding: 5px 10px;
  border-radius: 8px;
  background: #18181b;
  color: #fafafa;
  font-size: 0.76rem;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.12s ease, transform 0.12s ease;
}

:root[data-theme='dark'] .ui-tip {
  background: #27272a;
  color: #fafafa;
  border: 1px solid rgba(148, 163, 184, 0.18);
}

.lang-menu:hover .ui-tip,
.ui-tip-wrap:hover .ui-tip {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

/* У крайней справа кнопки подсказка прижата к краю, иначе обрезается */
.ui-tip--end {
  left: auto;
  right: 0;
  transform: translateY(-4px);
}

.ui-tip-wrap:hover .ui-tip--end {
  transform: translateY(0);
}

/* Меню открыто — подсказка не мешает */
.lang-menu-trigger.open ~ .ui-tip {
  opacity: 0;
}

/* Правая группа верхней полосы: язык · вкладка · разделитель · тема */
.tb-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tb-divider {
  width: 1px;
  height: 20px;
  background: var(--border-color, rgba(148, 163, 184, 0.28));
}
`, "",{"version":3,"sources":["webpack://./src/css/sidebar.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB;8DAC4D;EAC5D,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,qEAAqE;EACrE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,gFAAgF;AAChF;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,uEAAuE;AACzE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;EAEE,yDAAyD;EACzD,0BAA0B;AAC5B;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,wDAAwD;EACxD,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,aAAa;EACb,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gEAAgE;EAChE,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,oBAAoB,cAAc,EAAE;AACpC,sBAAsB,cAAc,EAAE;AACtC,0BAA0B,cAAc,EAAE;AAC1C,wBAAwB,cAAc,EAAE;;AAExC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gEAAgE;EAChE,mBAAmB;EACnB,uCAAuC;EACvC,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gEAAgE;EAChE,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,eAAe;EACf,sDAAsD;EACtD,2BAA2B;EAC3B,uEAAuE;AACzE;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA,sDAAsD;AACtD;EACE;IACE,4BAA4B;IAC5B,wCAAwC;IACxC,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,uDAAuD;EACvD;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,gEAAgE;EAChE,mBAAmB;EACnB,0DAA0D;EAC1D,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+DAA+D;EAC/D,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gEAAgE;EAChE,mBAAmB;EACnB,uCAAuC;EACvC,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yDAAyD;EACzD,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,SAAO;EACT;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,gEAAgE;EAChE,mBAAmB;EACnB,0DAA0D;EAC1D,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gEAAgE;EAChE,mBAAmB;EACnB,mCAAmC;EACnC,0BAA0B;EAC1B,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,gEAAgE;EAChE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,yDAAyD;AAC3D;;AAEA,mCAAmC;;AAEnC,+CAA+C;AAC/C;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;EAEE,yDAAyD;EACzD,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gEAAgE;EAChE,mBAAmB;EACnB,uCAAuC;EACvC,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,4CAA4C;EAC5C,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;;EAEE,UAAU;EACV,yCAAyC;AAC3C;;AAEA,uEAAuE;AACvE;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;EACE,UAAU;AACZ;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0DAA0D;AAC5D","sourcesContent":["/* ============================================================\n   Боковая навигация + узкая верхняя полоса.\n   Ширина сайдбара — переменная, от неё же считается отступ\n   контента, чтобы страницы не пересчитывали её вручную.\n   ============================================================ */\n\n:root {\n  --sb-width: 248px;\n  --sb-width-collapsed: 72px;\n  --tb-height: 56px;\n  /* Сколько по высоте занимают шапка и отступы контента —\n     используется страницами, которые тянутся на весь экран. */\n  --app-content-offset: 150px;\n}\n\n.app-layout {\n  min-height: 100vh;\n}\n\n/* ── Сайдбар ── */\n.sb {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 1100;\n  width: var(--sb-width);\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-glass-heavy, #fff);\n  border-right: 1px solid var(--border-color, rgba(148, 163, 184, 0.2));\n  backdrop-filter: blur(12px);\n  transition: width 0.2s ease, transform 0.2s ease;\n}\n\n/* Свёрнутый сайдбар прячется полностью — навигация остаётся в поиске (Ctrl+K) */\n.sb--collapsed {\n  transform: translateX(-100%);\n}\n\n.sb-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 14px 12px;\n  min-height: var(--tb-height);\n  border-bottom: 1px solid var(--border-color, rgba(148, 163, 184, 0.16));\n}\n\n.sb-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.sb-logo {\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n}\n\n.sb-brand-texts {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.sb-brand-name {\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--text-primary);\n  line-height: 1.1;\n}\n\n.sb-brand-sub {\n  color: var(--text-secondary);\n  font-size: 0.72rem;\n}\n\n.sb-collapse-btn,\n.tb-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n\n.sb-collapse-btn:hover,\n.tb-btn:hover {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));\n  color: var(--text-primary);\n}\n\n/* Глобальное легаси-правило делает любой <nav> фиксированным — перебиваем */\n.sb .sb-nav {\n  position: static;\n  inset: auto;\n  background: transparent;\n  box-shadow: none;\n  z-index: auto;\n}\n\n.sb-nav {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 12px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.sb-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.sb-section-label {\n  padding: 4px 10px 6px;\n  color: var(--text-secondary);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.sb-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 10px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.sb-item:hover {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));\n}\n\n.sb-item.active {\n  background: var(--nav-active-bg, rgba(37, 99, 235, 0.1));\n  color: var(--accent-primary, #2563eb);\n  font-weight: 600;\n}\n\n.sb-item-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 22px;\n}\n\n.sb-item-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sb--collapsed .sb-item {\n  justify-content: center;\n  padding: 10px 0;\n}\n\n.sb-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--accent-error, #dc2626);\n  color: #fff;\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\n.sb-badge--dot {\n  position: absolute;\n  transform: translate(12px, -10px);\n  min-width: 8px;\n  width: 8px;\n  height: 8px;\n  padding: 0;\n}\n\n.sb--collapsed .sb-item {\n  position: relative;\n}\n\n/* ── Подвал сайдбара: профиль, язык, выход ── */\n.sb-foot {\n  position: relative;\n  padding: 10px;\n  border-top: 1px solid var(--border-color, rgba(148, 163, 184, 0.16));\n}\n\n.sb-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.18));\n  border-radius: 12px;\n  background: transparent;\n  color: var(--text-primary);\n  text-align: left;\n  cursor: pointer;\n}\n\n.sb-user:hover {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.12));\n}\n\n.sb-user-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  border-radius: 50%;\n  background: var(--accent-primary, #2563eb);\n  color: #fff;\n  font-weight: 700;\n  font-size: 0.85rem;\n}\n\n.sb-user-texts {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n\n.sb-user-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sb-user-role {\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: var(--text-secondary);\n}\n\n.sb-user-role.dev { color: #a855f7; }\n.sb-user-role.admin { color: #dc2626; }\n.sb-user-role.moderator { color: #d97706; }\n.sb-user-role.support { color: #059669; }\n\n.sb-user-menu {\n  position: absolute;\n  left: 10px;\n  right: 10px;\n  bottom: calc(100% - 4px);\n  z-index: 20;\n  padding: 8px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));\n  border-radius: 12px;\n  background: var(--bg-glass-heavy, #fff);\n  box-shadow: 0 18px 40px -18px rgba(15, 23, 42, 0.45);\n}\n\n.sb-user-menu-label {\n  display: block;\n  padding: 4px 6px;\n  color: var(--text-secondary);\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.sb-langs {\n  display: flex;\n  gap: 6px;\n  padding: 4px 4px 8px;\n}\n\n.sb-lang {\n  flex: 1;\n  padding: 6px 4px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.25));\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.sb-lang.active {\n  background: var(--accent-primary, #2563eb);\n  border-color: var(--accent-primary, #2563eb);\n  color: #fff;\n}\n\n.sb-user-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 9px 10px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.sb-user-menu-item:hover {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));\n}\n\n.sb-user-menu-item.logout {\n  color: var(--accent-error, #dc2626);\n}\n\n/* ── Верхняя полоса ── */\n.tb {\n  position: sticky;\n  top: 0;\n  z-index: 900;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: var(--tb-height);\n  padding: 0 16px;\n  background: var(--bg-glass, rgba(255, 255, 255, 0.75));\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid var(--border-color, rgba(148, 163, 184, 0.16));\n}\n\n.tb-spacer {\n  flex: 1;\n}\n\n.tb-burger {\n  display: none;\n}\n\n/* ── Контент рядом с сайдбаром ── */\n.app-body {\n  margin-left: var(--sb-width);\n  min-height: 100vh;\n  transition: margin-left 0.2s ease;\n}\n\n.app-body--collapsed {\n  margin-left: 0;\n}\n\n/* Прежняя разметка рассчитывала на фиксированный навбар сверху */\n.app-layout .main-content {\n  margin-top: 0;\n  padding: 20px 24px;\n  min-height: calc(100vh - var(--tb-height));\n}\n\n.sb-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(2px);\n}\n\n/* ── Мобильные: сайдбар выезжает поверх контента ── */\n@media (max-width: 1024px) {\n  .sb {\n    transform: translateX(-100%);\n    box-shadow: 0 0 40px rgba(0, 0, 0, 0.25);\n    width: var(--sb-width);\n  }\n\n  .sb--open {\n    transform: translateX(0);\n  }\n\n  /* В выдвижной панели свёрнутый режим не имеет смысла */\n  .sb--collapsed {\n    width: var(--sb-width);\n  }\n\n  .sb--collapsed .sb-item {\n    justify-content: flex-start;\n    padding: 9px 10px;\n  }\n\n  .sb-collapse-btn {\n    display: none;\n  }\n\n  .app-body,\n  .app-body--collapsed {\n    margin-left: 0;\n  }\n\n  .tb-burger {\n    display: inline-flex;\n  }\n\n  .app-layout .main-content {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  :root {\n    --sb-width: 82vw;\n    --app-content-offset: 130px;\n  }\n\n  .app-layout .main-content {\n    padding: 12px;\n  }\n}\n\n/* Логотип: светлый и тёмный варианты знака */\n.brand-logo {\n  position: relative;\n  display: inline-flex;\n  flex: 0 0 auto;\n}\n\n.brand-logo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: 22%;\n}\n\n.brand-logo-img--dark {\n  display: none;\n}\n\n:root[data-theme='dark'] .brand-logo-img--light {\n  display: none;\n}\n\n:root[data-theme='dark'] .brand-logo-img--dark {\n  display: block;\n}\n\n/* ── Поиск и быстрые ссылки в верхней полосе ── */\n.tb-collapse {\n  display: inline-flex;\n}\n\n.tb-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: min(340px, 40vw);\n  padding: 7px 10px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));\n  border-radius: 10px;\n  background: var(--bg-secondary, rgba(148, 163, 184, 0.08));\n  color: var(--text-secondary);\n}\n\n.tb-search input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.86rem;\n}\n\n.tb-kbd {\n  padding: 2px 6px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));\n  border-radius: 6px;\n  color: var(--text-secondary);\n  font-size: 0.68rem;\n  font-family: var(--font-data, monospace);\n  white-space: nowrap;\n}\n\n.tb-search-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 6px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));\n  border-radius: 12px;\n  background: var(--bg-glass-heavy, #fff);\n  backdrop-filter: blur(12px);\n  box-shadow: 0 18px 44px -18px rgba(15, 23, 42, 0.5);\n}\n\n.tb-search-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 10px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.88rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.tb-search-item.active {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.16));\n}\n\n.tb-search-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tb-search-group {\n  color: var(--text-secondary);\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.tb-search-empty {\n  padding: 12px;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  text-align: center;\n}\n\n.tb-quick {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.tb-quick-link {\n  display: inline-flex;\n  align-items: center;\n  height: 34px;\n  padding: 0 12px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 0.86rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.tb-quick-link:hover {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));\n  color: var(--text-primary);\n}\n\n.tb-quick-link.active {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n@media (max-width: 1024px) {\n  .tb-collapse {\n    display: none;\n  }\n\n  .tb-quick,\n  .tb-divider {\n    display: none;\n  }\n\n  .tb-kbd {\n    display: none;\n  }\n\n  .tb-search {\n    width: auto;\n    flex: 1;\n  }\n}\n\n/* ── Палитра переходов (поиск в верхней полосе) ── */\n.tb-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: min(340px, 40vw);\n  padding: 8px 12px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));\n  border-radius: 10px;\n  background: var(--bg-secondary, rgba(148, 163, 184, 0.08));\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n\n.tb-search:hover {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.16));\n}\n\n.tb-search-text {\n  flex: 1;\n  text-align: left;\n  font-size: 0.86rem;\n}\n\n.tb-palette-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1500;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 12vh 24px 24px;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(3px);\n}\n\n.tb-palette {\n  width: min(520px, 100%);\n  max-height: 62vh;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));\n  border-radius: 16px;\n  background: var(--bg-primary, #fff);\n  color: var(--text-primary);\n  box-shadow: 0 28px 70px -24px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n\n.tb-palette-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 16px 8px;\n}\n\n.tb-palette-head h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n}\n\n.tb-palette-input {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 16px 10px;\n  padding: 9px 12px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.25));\n  border-radius: 10px;\n  color: var(--text-secondary);\n}\n\n.tb-palette-input input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n}\n\n.tb-palette-list {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 8px 12px;\n}\n\n.tb-palette-group-label {\n  display: block;\n  padding: 10px 10px 6px;\n  color: var(--text-secondary);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.tb-palette-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.92rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.tb-palette-item.active,\n.tb-palette-item:hover {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.16));\n}\n\n/* ── Список событий календаря ── */\n\n/* ── Переключатель языка в верхней полосе ── */\n.lang-menu {\n  position: relative;\n}\n\n.lang-menu-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  height: 34px;\n  padding: 0 9px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n\n.lang-menu-trigger:hover,\n.lang-menu-trigger.open {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));\n  color: var(--text-primary);\n}\n\n.lang-menu-list {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 1200;\n  min-width: 180px;\n  padding: 6px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));\n  border-radius: 12px;\n  background: var(--bg-glass-heavy, #fff);\n  backdrop-filter: blur(12px);\n  box-shadow: 0 18px 44px -18px rgba(15, 23, 42, 0.45);\n}\n\n.lang-menu-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  padding: 9px 12px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.lang-menu-item:hover {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));\n}\n\n.lang-menu-item.active {\n  font-weight: 600;\n  color: var(--accent-primary, #2563eb);\n}\n\n.lang-menu-list {\n  animation: lang-menu-in 0.15s ease-out;\n}\n\n@keyframes lang-menu-in {\n  from { opacity: 0; transform: translateY(-6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Общий тултип: тёмная плашка под кнопкой (язык, тема) */\n.ui-tip-wrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.ui-tip {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 50%;\n  transform: translateX(-50%) translateY(-4px);\n  z-index: 1250;\n  padding: 5px 10px;\n  border-radius: 8px;\n  background: #18181b;\n  color: #fafafa;\n  font-size: 0.76rem;\n  font-weight: 500;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.12s ease, transform 0.12s ease;\n}\n\n:root[data-theme='dark'] .ui-tip {\n  background: #27272a;\n  color: #fafafa;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n}\n\n.lang-menu:hover .ui-tip,\n.ui-tip-wrap:hover .ui-tip {\n  opacity: 1;\n  transform: translateX(-50%) translateY(0);\n}\n\n/* У крайней справа кнопки подсказка прижата к краю, иначе обрезается */\n.ui-tip--end {\n  left: auto;\n  right: 0;\n  transform: translateY(-4px);\n}\n\n.ui-tip-wrap:hover .ui-tip--end {\n  transform: translateY(0);\n}\n\n/* Меню открыто — подсказка не мешает */\n.lang-menu-trigger.open ~ .ui-tip {\n  opacity: 0;\n}\n\n/* Правая группа верхней полосы: язык · вкладка · разделитель · тема */\n.tb-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tb-divider {\n  width: 1px;\n  height: 20px;\n  background: var(--border-color, rgba(148, 163, 184, 0.28));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
